import { api } from "../../lib";

export type ErrorCategory = "accessioning" | "grossing" | "processing";

export interface ErrorDefinition {
  id: string;
  category: ErrorCategory;
  error: string;
  description: string | null;
  preventSignOff: boolean;
  blockCase: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateErrorInput {
  category: ErrorCategory;
  error: string;
  description?: string;
  preventSignOff?: boolean;
  blockCase?: boolean;
  isActive?: boolean;
}

export interface UpdateErrorInput extends Partial<CreateErrorInput> {
  id: string;
}

export const errorsService = {
  getAll: async () => {
    return api.get<ErrorDefinition[]>("/admin/errors");
  },

  getById: async (id: string) => {
    return api.get<ErrorDefinition>(`/admin/errors/${id}`);
  },

  create: async (input: CreateErrorInput) => {
    return api.post<ErrorDefinition>("/admin/errors", input);
  },

  update: async (input: UpdateErrorInput) => {
    const { id, ...updates } = input;
    return api.put<ErrorDefinition>(`/admin/errors/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/errors/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<ErrorDefinition>(`/admin/errors/${id}`, {
      isActive,
    });
  },
};
